import { useContext, useMemo } from "react";
import { AvailabilityContext } from "../Contexts/AvailabilityContext";
import getProducts from "../Data/Products";

export default function useProductData(selectedProduct, isMobile) {
  const { availability } = useContext(AvailabilityContext);
  const products = useMemo(() => getProducts(isMobile), [isMobile]);
  const productId = products[selectedProduct]?.id;
  const productInfo = productId ? availability[productId] : null;
  const availableQty = productInfo ? productInfo.available : null;
  const apiPrice = productInfo ? productInfo.price : null;

  return { products, availability, productId, productInfo, availableQty, apiPrice };
}
